<template>
  <div class="efun">
    <nuxt/>
    <transition name="fade">
      <to-top v-if="showToTop"></to-top>
    </transition>
  </div>
</template>
<style lang="less" scoped>
  html,
  body {
    height: 100%;
    margin: 0;
  }
</style>

<script>
  
  import toTop from '@components/common/toTop/index.vue';
  export default {
    components: {
      toTop
    },
    head() {
      return {
        script: [{
          src: 'https://res-download.vsplay.com/res_eu/common/js/efun.rem.min.2.js'
        }]
      };
    },
    data() {
      return {
        showToTop: false
      }
    },
    mounted() {
      this.$nextTick(function() {
        window.addEventListener('scroll', this.showTop); //滚动事件监听  
      });
      // 插入cdn的js和ga初始化js
      const gameCode = sessionStorage.getItem('gameCode');
      const gaId = sessionStorage.getItem('ga-id');
      let toolScript = document.createElement("script");
      let gaScript = document.createElement("script");
      let gaAnaly = document.createElement("script");

      toolScript.setAttribute('src', `https://res-download.vsplay.com/res_eu/activity/${gameCode}/gw/index.js`);
      gaAnaly.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${gaId}`);
      gaScript.innerHTML = `window.dataLayer = window.dataLayer || [];
                            function gtag(){dataLayer.push(arguments);}
                            gtag('js', new Date());
                            gtag('config', '${gaId}');`;

      document.body.insertBefore(toolScript, null)
      document.head.insertBefore(gaAnaly, null)
      document.head.insertBefore(gaScript, null)
    },
    methods: {
      //获取滚动条当前的位置 
      getScrollTop: function() {
        if (document.documentElement && document.documentElement.scrollTop) {
          return document.documentElement.scrollTop;
        } else if (document.body) {
          return document.body.scrollTop;
        }
      },
      showTop() {
        const scrollTop = this.getScrollTop();
        scrollTop >= 1000 ? this.showToTop = true : this.showToTop = false;
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// client/smsgz/layouts/default.vue